import { logError } from "../LocalLogger";
import { NetowrkPathTranslator } from "./NetowrkPathTranslator";
import { NetworkIdentity } from "./NetworkIdentity";

export class RestAPIProvider {
	static async fetchAPI(api: string, method = "GET", params: any = {}, dataField = "data", sendAuth = true): Promise<any> {
		if (Object.keys(params).length > 0 && method === "GET") {
			api += "?";
			Object.entries(params).forEach(([key, value]) => {
				api += `${key}=${value}&`;
			});
			params = {};
		}
		const newURL = NetowrkPathTranslator.getRestApiPath(api);
		const retData = await this.fetchURL(newURL, method, params, dataField, sendAuth);
		// logDebug('fetchAPI', api, method, params, 'response:', retData);
		return retData;
	}
	static async fetchURL(url: URL | string, method = "GET", params: any = {}, dataField = "data", sendAuth = true): Promise<any> {
		const isFormData = params instanceof FormData;
		if (typeof url === "string") {
			url = new URL(url);
		}

		const bearerHeader = sendAuth
			? await NetworkIdentity.getBearerHeaders()
			: {
					authToken: "none",
					uid: "none",
			  };
		let response;
		// logDebug('using lasso token', RestAPI._lassoToken)
		if (method === "POST") {
			response = await fetch(url, {
				method,
				body: isFormData ? params : JSON.stringify(params),
				headers: isFormData
					? bearerHeader
					: {
							"Content-Type": "application/json;charset=UTF-8",
							Accept: "application/json",
							...bearerHeader,
					  },
			});
		} else {
			try {
				const headers = {
					"Content-Type": "application/json;charset=UTF-8",
					Accept: "application/json",
					...bearerHeader,
				};
				// logDebug('sending headers', headers);
				response = await fetch(url, {
					method,
					headers,
				});
			} catch (error) {
				return null;
			}
		}
		try {
			// debugger;
			// TODO :: check success flag in response
			const data: any = await response.json();
			if (!data.success) {
				logError("Error in fetchURL :", url.href, params, data);
				alert(`Error fetching data from ${url.href}: ${data.data || "Unknown error"}`);
				return null;
			}
			NetworkIdentity.updateBackendToken(data);
			if (dataField && dataField in data) {
				return data[dataField];
			}
			return data;
		} catch (error) {
			try {
				const text: any = await response.text();
				return text;
			} catch (err) {
				logError("Error reading text from url :", err);
			}
		}
		return null;
	}
}
